//#region src/types.ts
const MACOS_CALENDAR_TEMPLATE_ID = "macos-calendar";
const MACOS_CALENDAR_BLOCKED_ACCOUNTS = "MACOS_CALENDAR_BLOCKED_ACCOUNTS";
const MACOS_CALENDAR_BLOCKED_CALENDARS = "MACOS_CALENDAR_BLOCKED_CALENDARS";
const MACOS_CALENDAR_LIST_CALENDARS = "MACOS_CALENDAR_LIST_CALENDARS";
function transportEnv(server) {
	return server.transport.kind === "http" ? {} : { ...server.transport.env };
}
function splitIds(raw) {
	return new Set((raw ?? "").split(",").map((id) => id.trim()).filter(Boolean));
}
function hiddenIds(server) {
	const env = transportEnv(server);
	return {
		accounts: splitIds(env[MACOS_CALENDAR_BLOCKED_ACCOUNTS]),
		calendars: splitIds(env[MACOS_CALENDAR_BLOCKED_CALENDARS])
	};
}
//#endregion
export { hiddenIds as a, MACOS_CALENDAR_TEMPLATE_ID as i, MACOS_CALENDAR_BLOCKED_CALENDARS as n, transportEnv as o, MACOS_CALENDAR_LIST_CALENDARS as r, MACOS_CALENDAR_BLOCKED_ACCOUNTS as t };

//# sourceMappingURL=types-BZ83z0Kl.js.map